export const createStudyRouteGenerationGuard = (initialStudyInstanceUID = '') => {
  let studyInstanceUID = initialStudyInstanceUID;
  let generation = 0;
  let token = { studyInstanceUID, generation };

  return {
    enter(nextStudyInstanceUID) {
      if (nextStudyInstanceUID !== studyInstanceUID) {
        studyInstanceUID = nextStudyInstanceUID;
        generation += 1;
        token = { studyInstanceUID, generation };
      }
      return token;
    },
    isCurrent(candidate) {
      return Boolean(
        candidate
        && candidate.generation === generation
        && candidate.studyInstanceUID === studyInstanceUID,
      );
    },
  };
};
